import React from 'react';

import { StyledSvg } from './LoadingSpinnerStyles';

var _ref = React.createElement(
  StyledSvg,
  { className: 'icon icon-spinner', viewBox: '0 0 50 50' },
  React.createElement('circle', { cx: '25', cy: '25', r: '20', fill: 'none', strokeWidth: '5' })
);

var LoadingSpinner = function LoadingSpinner() {
  return _ref;
};

export default LoadingSpinner;